module.exports = __webpack_public_path__ + "img/sn.4180a846.png";